import { RootState } from '../reducers'

export const intermediatePageSelector = (state: RootState, id: number) => state.intermediatePage[id]
